import languages from '../languages/languages';
import englishTranslation from '../translations/english';
import Translation from '../translations/Translation';
import Localization from './Localization';

const englishLocalization: Localization<Translation> = {
  language: languages.english,
  translatedStrings: englishTranslation,
};

export default englishLocalization;
